import React from 'react';
import { Card, CardBody } from 'reactstrap';
import './DashboardCard.css';

/**
 * Reusable Dashboard Card Component
 * Provides consistent card layout with title, subtitle, and content
 */
const DashboardCard = ({
  title,
  subtitle,
  children,
  loading = false,
  error = null,
  className = '',
  headerContent = null,
  footer = null
}) => {
  const renderHeader = () => {
    if (!title && !subtitle && !headerContent) return null;
    
    return (
      <div className="dashboard-card-header">
        <div className="dashboard-card-title-section">
          {title && <h5 className="dashboard-card-title">{title}</h5>}
          {subtitle && <p className="dashboard-card-subtitle">{subtitle}</p>}
        </div>
        {headerContent && <div className="dashboard-card-header-content">{headerContent}</div>}
      </div>
    );
  };

  const renderContent = () => {
    if (loading) {
      return <div className="dashboard-card-loading">Loading...</div>;
    }

    if (error) {
      return (
        <div className="dashboard-card-error">
          <div className="error-icon">⚠</div>
          <div className="error-message">{error}</div>
        </div>
      );
    }

    if (!children) {
      return (
        <div className="dashboard-card-empty">
          <div className="empty-icon">📭</div>
          <div className="empty-message">No data available</div>
        </div>
      );
    }

    return children;
  };

  return (
    <Card className={`dashboard-card ${className}`}>
      {renderHeader()}
      <CardBody className="dashboard-card-body">
        {renderContent()}
      </CardBody>
      {footer && <div className="dashboard-card-footer">{footer}</div>}
    </Card>
  );
};

export default DashboardCard;



// WEBPACK FOOTER //
// ./src/shared/components/DashboardCard/index.js